import { useLenis } from "lenis/react";
import { ChapterHeading, Reveal } from "./Reveal";

const COLLECTIONS = [
  {
    key: "signature",
    name: "Signature Residences",
    items: [
      "Residence 01 — 3 Bed / 3 Bath · 1,888 sq ft · From $3,527,000",
      "Residence 02 — 2 Bed / 2.5 Bath · 1,146 sq ft · From $2,126,000",
      "Residence 06 — 1 Bed / 1.5 Bath · 873 sq ft · From $1,336,000",
    ],
  },
  {
    key: "classic",
    name: "Classic Residences",
    items: [
      "Residence 09 — 1 Bed / 1 Bath · 682 sq ft · From $890,000",
      "Residence 07 — 1 Bed + Den · 778 sq ft · From $1,024,000",
      "Residence 08 — 1 Bed + Den · 766 sq ft · From $977,000",
      "Residence 10 — 2 Bed / 2 Bath · 956 sq ft · From $1,250,000",
      "Residence 05 — 2 Bed / 2 Bath · 956 sq ft · From $1,382,000",
      "Residence 03 — 2 Bed / 2 Bath · 995 sq ft · From $1,607,000",
      "Residence 11 — 3 Bed / 2 Bath · 1,662 sq ft · From $2,701,000",
    ],
  },
];

const Residences = () => {
  const lenis = useLenis();
  return (
    <section className="py-24 md:py-32" data-testid="residences-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ChapterHeading number="03" overline="The Residences" title="Ten floor plans, two collections." />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mt-14 md:mt-20 items-start">
          <Reveal className="lg:col-span-5">
            <p className="text-base text-stone2 leading-relaxed max-w-xl" data-testid="residences-body">
              Kali&rsquo;u offers ten residence types across two collections &mdash; Signature and Classic &mdash; ranging from 682 to 1,888 square feet, with 9-foot floor-to-ceiling windows throughout. Prices shown are the developer&rsquo;s published starting prices.
            </p>
            <button
              onClick={() => lenis?.scrollTo("#priority-list", { offset: -60, duration: 1.4 })}
              className="group relative overflow-hidden mt-10 bg-teal text-ivory px-8 py-4 text-xs tracking-[0.2em] uppercase font-semibold"
              data-testid="residences-walkthrough-cta"
            >
              <span className="absolute inset-0 bg-teal-deep translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
              <span className="relative">Get a Floor-Plan Walkthrough</span>
            </button>
            <p className="mt-6 text-xs text-stone2 leading-relaxed italic max-w-md" data-testid="residences-note">
              Floor plans and renderings are published by the developer and are available on the{" "}
              <a href="https://kaliualamoana.com/" target="_blank" rel="noopener noreferrer" className="text-teal underline underline-offset-2 not-italic" data-testid="residences-official-link">
                official Kali&rsquo;u website
              </a>
              . Prices are approximate starting figures; all details subject to change.
            </p>
          </Reveal>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-line border border-line" data-testid="residences-collections">
            {COLLECTIONS.map((c, i) => (
              <Reveal key={c.key} delay={i * 0.1} className="bg-ivory">
                <div className="p-8 md:p-10 h-full" data-testid={`collection-${c.key}`}>
                  <p className="text-[10px] tracking-[0.25em] uppercase font-semibold text-teal">{c.name}</p>
                  <ul className="mt-5">
                    {c.items.map((it) => (
                      <li key={it} className="font-serif text-lg font-light text-charcoal leading-snug border-b border-line/70 py-3 first:pt-0 last:border-0 last:pb-0">
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Residences;
